import { render } from "./ObjectsHeader.vue?vue&type=template&id=3e2dfbb4"
import script from "./ObjectsHeader.vue?vue&type=script&lang=js"
export * from "./ObjectsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__